import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDGTTl3GwC2wg5xeY9VJ1AXYe-2kxQNTXg",
  authDomain: "disfagiapp.firebaseapp.com",
  projectId: "disfagiapp",
  storageBucket: "disfagiapp.firebasestorage.app",
  messagingSenderId: "239413202085",
  appId: "1:239413202085:web:0d185881d8ab3da16ed14c",
  measurementId: "G-MNRMZH4NE4",
};

// Evita doble inicialización en dev/HMR
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// ✅ Exportaciones con nombre
export const auth = getAuth(app);
export const db = getFirestore(app);
export { app };